export const AD_MORE_TIME_CLICKED = 1;
export const AD_REPLAY_CLICKED = 2;
export const AD_BONUS_CHANCE_VIDEO = 3;
export const AD_SHOW_HINT_CLICKED = 4;



// WEBPACK FOOTER //
// ./src/js/utils/constants.js